export const namespace = 'orders';

export const MutationTypes = {
  SET_ORDER: 'SET_ORDER',
  SET_ORDERS: 'SET_ORDERS',
  SET_ORDER_HISTORY: 'SET_ORDER_HISTORY',
  SET_ORDER_ATTRIBUTES: 'SET_ORDER_ATTRIBUTES',
};

export const ActionTypes = {
  GET_ORDER: 'GET_ORDER',
  GET_ORDERS: 'GET_ORDERS',
  GET_ORDER_HISTORY: 'GET_ORDER_HISTORY',
  GET_ORDER_ATTRIBUTES: 'GET_ORDER_ATTRIBUTES',
};
